export default {
      id: "lax-drawer-open-usage",
      viewBox: "0 0 1000 823",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#lax-drawer-open",
      toString: function () {
        return this.url;
      }
    }